"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.FeefoHighlightedSnippets = void 0;

var _feefoHighlightedSnippets = _interopRequireDefault(require("./components/feefo-highlighted-snippets"));

exports.FeefoHighlightedSnippets = _feefoHighlightedSnippets["default"];